import { useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../redux/apiCalls";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const dispatch = useDispatch();

    const handleClick = () => {
        login(dispatch, { email, password });
    };

    const backgroundImage = process.env.REACT_APP_PROJECT === "JINSORA"
        ? "https://ik.imagekit.io/dnddecpho/Jinsora/409800244_346925417935685_3678391952786727504_n_RbtZWr5il.jpg"
        : "https://ik.imagekit.io/dnddecpho/IHGroup/Awning-8-1030x644-1_5z_4JatQb.jpg";

    return (
        <div
            className="loginBackground"
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 16,
                background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage}) center`,
                backgroundSize: "cover",
                backgroundPosition: "bottom",
            }}
        >
            <img
                src={
                    process.env.REACT_APP_PROJECT === "JINSORA"
                        ? "https://ik.imagekit.io/dnddecpho/Jinsora/jinsora-logo_sO90GIVIc.jpeg"
                        : "https://ik.imagekit.io/dnddecpho/IHGroup/inhome-logo_ohlG8QLO0.png?updatedAt=1754324519910"
                }
                alt="IH Group logo"
                className="loginLogo"
            />
            <input
                style={{ padding: 10, marginBottom: 20 }}
                type="text"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
            />
            <input
                style={{ padding: 10, marginBottom: 20 }}
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
            />
            <button
                className="bg-black text-white"
                onClick={handleClick}
                style={{ padding: 10, width: 100 }}
            >
                Login
            </button>
        </div>
    );
};

export default Login;
